<div
    class="d-flex align-items-center justify-content-center badge rounded-pill visibility {{ MODULE_BADGE_LABELS_MAP[labelKey]?.cssClass }}"
    [title]="'MODULES.MODULE_STATUS' | translate"
    data-uit="module-detail-banner-label"
>
    {{ MODULE_BADGE_LABELS_MAP[labelKey]?.translationKey | translate }}
</div>
